<div class="utilidex-logo-cont pl-4 ml-1 lt-4 d-sm-block">
  <img src="../../../assets/images/utilidex_logo.png">
</div>
<div class="container register-container">
  <div class="row login-row">
    <div class="heading-cont col-md-5 offset-lg-2 text-white my-auto align-items-center" style="max-width: 565px;">
      <h1 class="heading" style="font-size: 450%">Financial Regulation Made Easy</h1>
    </div>
    <div class="col-md-5 col-lg-4 my-auto d-flex align-items-center">
      <div class="col-md-12 mx-auto">
        <!-- form card login -->
        <div class="card box-shadow" id="login-form">
          <div class="card-header bg-blue">
            Sign Up
          </div>
          <div class="card-body">
            <form accept-charset="UTF-8" [formGroup]="registerForm" role="form" #formData='ngForm'>
              <div class="row">
                <div class="col-md-12">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" id="inlineFormInputGroup" #FirstName placeholder="First Name"
                      name="FirstName" required formControlName="FirstName" [formGroup]="registerForm">             
                      <small class="text-danger col-md-12 p-0 mt-2" *ngIf="!registerForm.controls['FirstName'].value && registerForm.controls['FirstName'].touched">
                        First name is a required field
                      </small>
                  </div> 
                </div>

                <div class="col-md-12">
                  <div class="input-group mb-3">
                    <input type="text" class="form-control" #LastName placeholder="Last Name" name="LastName"
                      formControlName="LastName" [formGroup]="registerForm" required>                
                      <small class="text-danger col-md-12 p-0 mt-2" *ngIf="!registerForm.controls['LastName'].value && registerForm.controls['LastName'].touched">
                        Last name is a required field
                      </small>
                  </div>  
                </div>

                <div class="col-md-12">
                  <div class="input-group mb-3">
                    <input type="email" class="form-control" #EmailId placeholder="Email Id" name="EmailId"
                      formControlName="EmailId" [formGroup]="registerForm" required>
                      <small class="text-danger col-md-12 p-0 mt-2" *ngIf="registerForm.controls['EmailId'].value && !registerForm.controls['EmailId'].valid && registerForm.controls['EmailId'].touched">
                        Please enter a valid email
                      </small>
                      <small class="text-danger col-md-12 p-0 mt-2" *ngIf="!registerForm.controls['EmailId'].value && registerForm.controls['EmailId'].touched">
                        Email is a required field
                      </small>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="input-group mb-3">
                    <input type="password" type="password" autocomplete="new-password" class="form-control" placeholder="Password"
                      (ngModelChange)="passValidationTest($event)" name="Password" formControlName="Password"
                      [formGroup]="registerForm" (focusout)="hidePassVlidationBox()" required>
                  </div>

                  <div id="pswd_info" class=col-md-12 *ngIf="passwordErrorList.length > 0">
                    <h6>
                      <i class="fa fa-lock"></i> Your password must: </h6>
                    <ul class="list-group">
                      <li *ngFor="let item of passwordErrorList">
                        <span [ngClass]="(item.status == 1)?'invalid':'valid'">
                          <i class="fa " [ngClass]="(item.status == 1)?'fa-close':'fa-check'"></i>
                          {{item.errorMsg}}</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="col-md-12">
                  <label class="sr-only" for="inlineFormInputGroup">Confirm Password</label>
                  <div class="input-group mb-3">
                    <input type="password" type="password" placeholder="Confirm password" class="form-control" id="ConfirmPassword"
                      formControlName="ConfirmPassword" [formGroup]="registerForm" required>
                    <small *ngIf="!registerForm.controls['ConfirmPassword'].valid && registerForm.controls['ConfirmPassword'].touched"
                      class="text-danger col-md-12 p-0">
                      Password did not match.
                    </small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-2">
                  <app-progress-bar [isLoading]="isLoading"></app-progress-bar>
                </div>
                <small class="text-left text-success col-md-12 mb-2" *ngIf="response && isSuccess">{{ response
                  }}</small>
                <small class="text-left text-danger col-md-12 mb-2" *ngIf="response && !isSuccess">{{ response
                  }}</small>
                <div class="col-md-12">
                  <button type="submit" id="register-btn" [disabled]="!registerForm.valid" class="btn btn-sm btn-alt width-full m-0">
                    Sign Up</button>
                </div>
                <div class="col-md-12 text-left mt-2">
                  <a routerLink="/login/" style="cursor: pointer;">Login</a>
                  If you already have an account.
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!--col-md-12-->
  </div>
  <!--row-->
</div>
<!--continer-->
<app-footer></app-footer>
